export default __webpack_public_path__ + "static/media/knex.2609d425.png";